import { PILLAR, WELL, COUPLING, FOB, CABLE, PON_BOX } from "../Optics/Constants/ConstantsOptics";
import { Snackbar } from '@mui/material';
import CustomSnackbar from "../Optics/Components/CustomSnackbar";
import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import React, { useState} from "react";
import { DELETE_ADMIN_COMPONENTS_STATUS_API_URL, GET_ADMIN_LIST_STATUS_COMPONENT_API_URL } from "../Optics/OpticApiConfig";
import axios from 'axios';

const AdminDeleteStatusComponent = ({ open, onClose }) => {

    const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();

    const [selectedComponent, setSelectedComponent] = useState('');
    const token = localStorage.getItem('token');
    const [data, setData] = useState([]);
    const [isDataLoaded, setIsDataLoaded] = useState(false);

    const onCloseModal = async () => {
        setSelectedComponent('');
        setData([]);
        setIsDataLoaded(false);
        onClose();
    }

    const getListStatusComponents = async () => {
        setData([]);
        setIsDataLoaded(false);

        if(selectedComponent === ''){
            showSnackbar('Пустой ID или тип компонента!!!', 'snackbarWarning');
            return;
        }
        try {
            const response = await axios.get(
                `${GET_ADMIN_LIST_STATUS_COMPONENT_API_URL}`,
                {
                    params: { flag: selectedComponent },
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}` 
                    }
                }
            );
            setData(response.data);
            setIsDataLoaded(response.data.length > 0);
        } catch (error) {
            console.error('Ошибка при получении данных:', error);
        }
    };

    const deleteComponents = async () => {
        let apiEndpoint = '';

        if (!token) {
            showSnackbar('Ошибка! Токен не найден', 'snackbarWarning');
            return;
        }

        if (selectedComponent !== "") {
                apiEndpoint = `${DELETE_ADMIN_COMPONENTS_STATUS_API_URL}?flag=${selectedComponent}`;
        }else{
            showSnackbar('Выберите тип компонента', 'snackbarWarning');
        }
          
        try {
            const response = await fetch(apiEndpoint, { 
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}` 
                }
            });
        
            if (response.ok) {
                const data = await response.json();
                const message = data.message;
                const deletedCount = data.deletedCount;
                showSnackbar(`${message}. Количество записей: ${deletedCount}`, 'snackbarWarning');
                setSelectedComponent('');
                setData([]);
                setIsDataLoaded(false);
            } else {
                const errorMessage = await response.json();
                const message = errorMessage.message;
                showSnackbar(message, 'snackbarWarning');
            }
        } catch (error) {
            showSnackbar('Произошла ошибка!', 'snackbarWarning');
        }
        
     
    };
    
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="lg" 
            PaperProps={{
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    padding: '20px',
                    overflowX: 'auto',
                },
            }}
            className="modalStyle"
        >
            <DialogContent>
            <label style={{ color: '#dfab01', fontSize: '20px', fontFamily: 'unset' }}>Удаление компонентов где Status=0</label>
                <hr className='horizontalLineModal' />
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <select
                        className="selectStyleModal"
                        value={selectedComponent}
                        style={{width:"200px", marginTop: "17px"}}
                        onChange={(e) => setSelectedComponent(e.target.value)}
                    >
                        <option value="">Тип компонента</option>
                        <option value={PILLAR}>Опоры</option>
                        <option value={WELL}>Колодцы</option>
                        <option value={COUPLING}>Муфты</option>
                        <option value={FOB}>Фобы</option>
                        <option value={CABLE}>Кабеля</option>
                        <option value={PON_BOX}>Пон-боксы</option>
                    </select>
                    <br />

                    <button className='buttonIsChangeModal' style={{width: "auto"}} onClick={getListStatusComponents}>Поиск</button>

                    <hr className='horizontalLineModal' />
                </div>
                {isDataLoaded && (
                    <> 
                        <label style={{ fontSize: '16px', fontFamily: 'unset' }}>
                            <span style={{ color: '#d3d3d3' }}>Количество записей: </span> 
                            <span style={{ color: '#dfab01' }}>{data.length}</span>
                        </label>                      
                       <button className='buttonIsDeleteModal' style={{ width: "auto", marginLeft:"10px", marginTop:"5px", marginBottom: "10px" }} onClick={deleteComponents}>Удалить</button> 
                    </>
                    )}
                <br/>
                <div className="table-container">
                <table className="custom-table">
               
            <thead>
                <tr>
                    <th>Тип</th> 
                    <th>ID</th>                  
                    <th>Имя</th>
                    <th>Комент</th>
                    <th>Округ</th>     
                    <th>Создано</th>
                    <th>Статус</th>
                    <th>Создал</th>                 
                    <th>Ранг</th>
                </tr>
            </thead>
            <tbody>
                {data.map((item) => (
                    <tr key={item.id}>
                        <td>{item.type}</td>
                        <td>{item.id}</td>                      
                        <td>{item.couplingName || item.fobName}</td>
                       <td>{item.description?.slice(0, 50)}{item.description?.length > 50 ? '...' : ''}</td>
                        <td>{item.canton}</td>                     
                        <td>{new Date(item.createDate).toISOString().slice(0, 19).replace("T", " ")}</td>
                        <td>{item.status}</td>
                        <td>{item.authorId}</td>                      
                        <td>{item.rankComponentName}</td>
                    </tr>
                ))}
            </tbody>
        </table>
       
        </div>
        <hr className='horizontalLineModal' />
            </DialogContent>
            <DialogActions>
                <Button onClick={onCloseModal} class="buttonIsHideModal">
                    Закрыть
                </Button>
            </DialogActions>

             {/* Snackbar */}
                <Snackbar
                    anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                    }}
                    open={snackbarOpen}
                    autoHideDuration={6000}
                    onClose={handleCloseSnackbar}
                    message={snackbarMessage}
                    ContentProps={{
                        style: {
                        color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
                        }
                    }}
                    />
        </Dialog>
    );
};

export default AdminDeleteStatusComponent;